import React, { useEffect, useState } from "react";
import { usersByType } from "../callable-cloud-functions/cloudFunctions";
import DateGeneric from "../components/custom-ui/old-ui/DateGeneric";
import { getUsersWithAffiliations } from "../callable-cloud-functions/cloudFunctions";
import { csvDownload } from "../components/dashboard/AdminMetricDashboard/ExportCsv";
import DownloadIconWithLabel from "../components/dashboard/AdminMetricDashboard/DownLoadIcon";

const toArray = (object) => {
  const ret = [];
  for (const key in object) {
    const item = {};
    const val = object[key];
    item[key] = val;
    ret.push(item);
  }
  return ret;
};

const affiliationValue = [
  {
    name: "Military Spouse",
    value: "S",
  },
  {
    name: "Military Family Member",
    value: "FM",
  },
  {
    name: "Retired",
    value: "R",
  },
  {
    name: "Veteran",
    value: "V",
  },
];

function UsersByType() {
  const [values, setValues] = useState([]);
  const [affiliationTypes, setAffilliationTypes] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [affiliationType, setAffiliationType] = useState("");
  const [loadingStates, setLoadingStates] = useState({
    loading: false,
  });

  useEffect(() => {
    async function fetchData() {
      const { data } = await usersByType();
      if (data?.affiliationTypes) {
        const arr = toArray(data.affiliationTypes);
        setAffilliationTypes(arr);
      }
      const dataArr = toArray(data);
      setValues(dataArr);
    }
    fetchData();
  }, []);

  const handleDownload = async (loadingKey, fileName) => {
    setLoadingStates((prev) => ({ ...prev, [loadingKey]: true }));

    // Validate dates
    if (!startDate || !endDate) {
      alert("Please select both start and end dates.");
      setLoadingStates((prev) => ({ ...prev, [loadingKey]: false }));
      return;
    }

    if (!affiliationType) {
      alert("Please select affiliation type.");
      setLoadingStates((prev) => ({ ...prev, [loadingKey]: false }));
      return;
    }

    if (startDate.getTime() >= endDate.getTime()) {
      alert(
        "Please select a valid date range (start date must be before end date).",
      );
      setLoadingStates((prev) => ({ ...prev, [loadingKey]: false }));
      return;
    }

    try {
      console.log(
        "Downloading data from",
        startDate.getTime(),
        "to",
        endDate.getTime(),
      );

      const response = await getUsersWithAffiliations({
        startDate: startDate.getTime(),
        endDate: endDate.getTime(),
        affiliationType
      });

      const { data, fileName: fetchedFileName } = response.data;

      if (!data.length) {
        alert("No data found in the selected range.");
        return;
      }

      csvDownload(data, fetchedFileName || fileName);
    } catch (error) {
      console.error("Error during download:", error);
      alert("Something went wrong while downloading the data.");
    } finally {
      setLoadingStates((prev) => ({ ...prev, [loadingKey]: false }));
    }
  };

  return (
    <div className="w-full bg-[#E6F1FC] shadow-lg rounded-lg overflow-hidden">
      <div className="flex flex-wrap items-center justify-left text-xl font-extrabold text-[#1E596D] mb-4 p-3 border-b border-gray-300">
        Users by Type
      </div>
      {/* Date Range Picker & Download Button */}
      <div className="flex flex-wrap gap-2 items-end px-4 pb-4 justify-right">
        <div className="w-50">
          <DateGeneric
            name="startDate"
            display="From Date"
            value={startDate}
            onChange={setStartDate}
            timestamp={true}
            required
            dateLimit="past"
          />
        </div>
        <div className="w-50">
          <DateGeneric
            name="endDate"
            display="To Date"
            value={endDate}
            onChange={setEndDate}
            timestamp={true}
            required
            dateLimit="past"
          />
        </div>
        <div>
          <select
            className="border border-[#1E596D] w-56 bg-white rounded-lg p-2 text-[#1E596D]"
            value={affiliationType}
            onChange={(e) => setAffiliationType(e.target.value)}
          >
            <option value="" disabled>
              Select Affiliation Type{" "}
            </option>
            {affiliationValue.map((option, index) => (
              <option className="bg-white p-2" key={index} value={option.value}>
                {option.name}
              </option>
            ))}
          </select>
        </div>
        <div className="flex items-end">
          <p className="text-[#1E596D] text-[12px]">
            Download Self Affiliated Users List
          </p>
          <div className="flex mt-3 items-end">
            <div
              className="ml-3"
              onClick={() => handleDownload("loading", "user_list")}
            >
              {loadingStates.loading ? (
                <p className="text-sm  text-[#15404e]">Downloading...</p>
              ) : (
                <DownloadIconWithLabel
                  tooltipText="Download users from selected date range and type."
                  viewDown={true}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Display user type data */}
      <div className="w-full px-4 border-t border-gray-300">
        {values &&
          values.map((value, index) => {
            const label = Object.keys(value)[0];
            if (label !== "affiliationTypes" && label !== "createdAt") {
              if (label === "Affiliated") {
                const affiliatedCount = value[label];
                return (
                  <div key={index} className="mb-4">
                    <div className="w-full text-[#1E596D]">
                      {label}
                      <span className="float-right">{affiliatedCount}</span>
                    </div>
                    {affiliationTypes &&
                      affiliationTypes.map((value, index) => {
                        const label = Object.keys(value)[0];
                        const count = value[label];
                        return (
                          <div
                            key={index}
                            className="w-full pl-4 text-[#1E596D]"
                          >
                            {label}
                            <span className="float-right">{count}</span>
                          </div>
                        );
                      })}
                  </div>
                );
              } else {
                const count = value[label];
                return (
                  <div key={index} className="text-[#1E596D]">
                    {label}
                    <span className="float-right">{count}</span>
                  </div>
                );
              }
            }
          })}
      </div>
    </div>
  );
}

export default UsersByType;
